export const APP_STORE_URL = "https://apps.apple.com/in/app/setgo-deals/id6778716217";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.setgoinnovations";
export const PARTNER_REGISTER_URL = "https://register.setgoinnovations.com/";

/**
 * Returns the relevant store URL depending on the user's operating system.
 * Directs iOS users to the Apple App Store, and others to the Google Play Store.
 */
export function getSmartAppDownloadUrl(): string {
  if (typeof window === "undefined") return PLAY_STORE_URL;
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || "";
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return APP_STORE_URL;
  }
  return PLAY_STORE_URL;
}
